export default __webpack_public_path__ + "static/media/portals500x642.43fb2612.png";